import React, {useState, useEffect} from 'react'
import { StyledModal, PostPopupTop, StyledBody } from '../PhotoAndPostFlow/styles';
import {AdminCloseIcon} from '../../utils/icons'
import PropTypes from "prop-types";
import {AddUserCard} from './styles'
import {ImageUrl} from '../../utils/constants'
import {CommonButton} from '../common/commonStyles'
import {RadioButton, RadioButtonWrapper } from '../RecogntionAdmin/styles'
import { TextAreaWrapperSearchPopup, SelectedUserWrapper } from '../ChallengeDetailsV2/styles';
import { Searchuserswithindepartment, Addmanagertodepartment, SearchUsersWithinLocation, AddManagerToLocation } from '../../redux/constants/apiConstants';
import { toast } from 'react-toastify';
import { fetchApi, getInitials } from '../../utils/methods';
import { NameInitials } from "../Manager/styles";

const AddManager = ({showModal, setHideShow, companyId, getSelectedId, getManagerDataByDepartment,type}) => {

  const [selected, seteSelect]=useState(null)
  const [searchUser, setSearchUser]=useState('')
  const [getSearchUserData, setSearchUserData]=useState([])
  const [showLoader, setLoader]=useState(false)

  const handleSelect = (id) => {
    seteSelect(id)
  }

  const handleChange = (e) => {
    setSearchUser(e.target.value)
  }

  const object ={
    "company_id": companyId,
    [type === 'location' ? 'location_id' : "department_id"]: getSelectedId,
    "name": searchUser
  }

  

  useEffect(() => {
    const timer = window.setTimeout(() => {
      updateInitiative(object);
    }, 2000); // 2000ms = 2 seconds
  
    return () => window.clearTimeout(timer); // Cleanup if `searchUser` changes quickly
  }, [searchUser]);

  const updateInitiative = async (obj) => {
    
    try {  
      const res = await fetchApi(`${type === 'location'? SearchUsersWithinLocation : Searchuserswithindepartment}`,"POST", obj);
  
      if (res?.status === "success") {
        setSearchUserData(res.data);
        setLoader(true)
      } else {
        setLoader(true)
        toast.error(res?.data?.message || "Something went wrong while fetching users.");
      }
    } catch (error) {
      toast.error(error?.data?.message || "An unexpected error occurred.");
    }
  };

  const onAddMember = () =>{
    const object ={
      "company_id": companyId,
      [type === 'location' ? 'location_id' : "department_id"]: getSelectedId,
      "manager_id": selected
    }
    addMember(object)
  }

  const addMember = async (obj) => {
    
    try {  
      const res = await fetchApi(`${ type === 'location'?AddManagerToLocation:Addmanagertodepartment}`,"POST", obj);
      if (res?.status === "success") {
        toast.success(res?.data?.message || "Manager added");
        getManagerDataByDepartment(companyId)
        setHideShow(false,null)
      } else {
        toast.error(res?.data?.message || "Something went wrong while fetching users.");
      }
    } catch (error) {
      toast.error(error.message || "An unexpected error occurred.");
    }
  };

  return(
    <>
      <StyledModal show={showModal} width="600px" background="#F8F8F8" height="auto">
        <PostPopupTop>
          <div className='heading'>{"Add Manager"}</div>
          <div className='closeIcon' onClick={()=>setHideShow(false, null)} >{AdminCloseIcon()}</div>
        </PostPopupTop>
        <div style={{ height: "1px", width: "100%", background: "#EFEFEF", margin: "0" }} />
        <StyledBody paddingValue="16px 24px">
          <div className='heading-title'>Select user to add as a manager</div>
          <TextAreaWrapperSearchPopup margin="8px 0 24px 0">
            <SelectedUserWrapper width={"100%"}>
              <textarea
                id="inlineAutoTextarea"
                value={searchUser}
                onChange={handleChange}
                placeholder=""
              />
            </SelectedUserWrapper>
          </TextAreaWrapperSearchPopup>
          <div className='wrap' style={{maxHeight:"400px", overflowY:"scroll",paddingRight:"10px"}}>
            {getSearchUserData?.length===0?showLoader&&<div className='no-data'>No data found</div>:  getSearchUserData?.map((data,index)=>
              <AddUserCard key={index}>
                {data.profile_image !== "profile-Image/default.png" ?
                  <div className='image'>
                    <img src={ImageUrl+"/"+data.profile_image}/>
                  </div>:
                  <NameInitials id="name-initials">
                    {getInitials(data?.fname)}{getInitials(data?.lname)}
                  </NameInitials> 
                }
                <div className='name'>{data.fname}{" "}{data?.lname}</div>
                <div className='checkbox' onClick={() => handleSelect(data?.uid)}>
                  <RadioButtonWrapper>
                    <div className='RadioButtonContainer'>
                      <RadioButton
                        type="radio"
                        checked={selected === data?.uid}
                        handler={handleSelect}
                      />
                    </div>
                  </RadioButtonWrapper>
                </div>
              </AddUserCard>)
            }
          </div>
          <div className='button-wrap'>
            <CommonButton disabled={selected?0:1} onClick={selected? ()=>onAddMember():null}>Save Changes</CommonButton>
          </div>
        </StyledBody>
      </StyledModal>
    </>
  )
}

AddManager.propTypes = {
  showModal: PropTypes.bool,
  setHideShow: PropTypes.func,
  getSelectedId: PropTypes.number,
  companyId: PropTypes.number,
  getManagerDataByDepartment: PropTypes.func,
  type:PropTypes.string
};

export default AddManager